import has from 'lodash/has'
import get from 'lodash/get'
import { useSelector } from 'react-redux';
import { AppState } from '../store'

/**
 * Hook używany do dodawania tekstów na stronę.
 * Jeśli teksty nie zostaną pobrane z mongo, oznacza to błąd i kierujemy użytkownika na stronę z błędem.
 * jeśli i tam nie zostanie znaleziony zwróci pusty string.
 *
 * Funkcja zwracana przez hook, daje znam możliwość odwoływania się do kolejnych struktur zwracanego JSONa za pomocą standardowych operatorów: ".", "[n]" itp.
 * Dokumentacja funkcji używanej do dostepu do odpowiednich wartości z JSONa: https://lodash.com/docs/4.17.15#get
 *
 * Przykład użycia funkcji zwracanej przez hooka: useTextContent('key1.key2.key3[0].key4')
 * 24.06.2025 - Funkcja została rozszerzona o mechanizm uzupełniania tekstów o zmienne. Zmienne w tekstach oznaczane są jako ${nazwa_zmiennej}
 * Po podaniu obiektu klucz-wartość jako drugiego parametru funkcji, zmienne zostaną uzupełnione o wartości z tego obiektu.
 * Jedynym warunkiem jest to, aby nazwy kluczy w przekazywanym obiekcie były takie same jak nazwy zmiennych w tekście.
 * @returns {Func}
 */
const useTextContents = (): ((key: string, vars?: Record<string, string | null | undefined>) => string)  =>  {
  const textContentsFromBackend = useSelector((state: AppState) => state.textContentsState)

  const getTextContents = (key: string, vars: Record<string, string | null | undefined> = {}): string => {
     if (!has(textContentsFromBackend, key)) {
        if (process.env.NODE_ENV === 'development') {
           console.warn(`Brak klucza "${key}" zarówno w bazie danych, jak i w pliku JSON.`);
         }

         return '';
      }

      //Błąd biblioteki lodash - bez poniższej linijki build na TC nie przechodzi
      //@ts-ignore
      const rawText: string = get(textContentsFromBackend, key)

      const interpolated = rawText.replace(/\$\{(\w+)\}/g, (_match, varName: string): string => {
         const value = vars[varName];

         if (typeof value === 'string' && value !== '') {
            return value
         }

         if (process.env.NODE_ENV === 'development') {
            console.warn(
               `Brak lub pusta wartość dla zmiennej "${varName}" w szablonie "${key}".`
            )
         }

         return `$\{${varName}}`
      })

      return interpolated
  }

  return getTextContents
}

export default useTextContents